// /**
//  * Product Length Price Calculator
//  * Dynamically updates product prices based on selected length
//  * 
//  * This component handles:
//  * - Updating displayed price when length changes
//  * - Storing the base price per meter
//  * - Calculating total price based on length multiplier
//  * - Updating all price displays (regular, compare-at, unit prices)
//  */

// if (!customElements.get('product-length-selector')) {
//   customElements.define('product-length-selector', class ProductLengthSelector extends HTMLElement {
//     constructor() {
//       super();
      
//       this.slider = this.querySelector('[data-length-input]');
//       this.lengthDisplay = this.querySelector('[data-length-display]');
//       this.lengthProperty = this.querySelector('[data-length-property]');
//       this.lengthMultiplier = this.querySelector('[data-length-multiplier]');
      
//       // Find the product form and price elements
//       this.productForm = this.closest('.product-form') || this.closest('form');
//       this.priceContainer = document.querySelector('.price');
      
//       // Wait for DOM to be fully ready before storing prices
//       if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', () => {
//           this.basePrices = this.storBasePrices();
//           console.log('Length Selector: Base prices stored', this.basePrices);
//         });
//       } else {
//         this.basePrices = this.storBasePrices();
//         console.log('Length Selector: Base prices stored', this.basePrices);
//       }
      
//       if (this.slider) {
//         this.slider.addEventListener('input', this.onSliderChange.bind(this));
//       }
//     }

//     storBasePrices() {
//       const prices = {};
      
//       // Try multiple selectors for regular price
//       const regularPriceEl = document.querySelector('.price__regular .price-item--regular') || 
//                             document.querySelector('.price .price-item--regular') ||
//                             document.querySelector('.price__regular');
//       if (regularPriceEl) {
//         prices.regular = this.extractPrice(regularPriceEl.textContent);
//         console.log('Regular price found:', prices.regular, regularPriceEl.textContent);
//       } else {
//         console.warn('Length Selector: Could not find regular price element');
//       }
      
//       // Get sale price if exists
//       const salePriceEl = document.querySelector('.price__sale .price-item--sale') ||
//                           document.querySelector('.price-item--sale');
//       if (salePriceEl) {
//         prices.sale = this.extractPrice(salePriceEl.textContent);
//         console.log('Sale price found:', prices.sale);
//       }
      
//       // Get compare-at price if exists
//       const comparePriceEl = document.querySelector('.price__sale .price-item--regular');
//       if (comparePriceEl && comparePriceEl !== regularPriceEl) {
//         prices.compare = this.extractPrice(comparePriceEl.textContent);
//         console.log('Compare price found:', prices.compare);
//       }
      
//       // Get unit price if exists
//       const unitPriceEl = document.querySelector('.unit-price .unit-price__price');
//       if (unitPriceEl) {
//         prices.unit = this.extractPrice(unitPriceEl.textContent);
//       }
      
//       return prices;
//     }

//     extractPrice(priceString) {
//       // Remove currency symbols and extract numeric value
//       // Handles formats like £25.23, $25.23, 25,23€, etc.
//       const cleanString = priceString.replace(/[^\d.,]/g, '');
//       const normalizedString = cleanString.replace(',', '.');
//       return parseFloat(normalizedString) || 0;
//     }

//     formatPrice(price, currencySymbol = '£') {
//       // Format price to 2 decimal places
//       return `${currencySymbol}${price.toFixed(2)}`;
//     }

//     onSliderChange(event) {
//       const length = parseFloat(event.target.value);
      
//       // Round to 1 decimal place to avoid floating point issues
//       const roundedLength = Math.round(length * 10) / 10;
      
//       // Update display
//       if (this.lengthDisplay) {
//         this.lengthDisplay.textContent = `${roundedLength.toFixed(1)}m`;
//       }
      
//       // Update hidden inputs
//       if (this.lengthProperty) {
//         this.lengthProperty.value = roundedLength.toFixed(1);
//       }
      
//       if (this.lengthMultiplier) {
//         this.lengthMultiplier.value = roundedLength.toFixed(1);
//       }
      
//       // Update prices
//       this.updatePrices(roundedLength);
      
//       // Dispatch custom event for other components to listen to
//       this.dispatchEvent(new CustomEvent('length:changed', {
//         bubbles: true,
//         detail: { length: roundedLength }
//       }));
//     }

//     updatePrices(length) {
//       console.log('Updating prices for length:', length, 'Base prices:', this.basePrices);
      
//       // Update regular price
//       const regularPriceEl = document.querySelector('.price__regular .price-item--regular') || 
//                             document.querySelector('.price .price-item--regular') ||
//                             document.querySelector('.price__regular');
//       if (regularPriceEl && this.basePrices.regular) {
//         const newPrice = this.basePrices.regular * length;
//         const currencySymbol = this.getCurrencySymbol(regularPriceEl.textContent);
//         regularPriceEl.textContent = this.formatPrice(newPrice, currencySymbol);
//         console.log('Updated regular price to:', regularPriceEl.textContent);
//       } else {
//         console.warn('Could not update regular price', {regularPriceEl, basePrice: this.basePrices.regular});
//       }
      
//       // Update sale price if exists
//       const salePriceEl = document.querySelector('.price__sale .price-item--sale');
//       if (salePriceEl && this.basePrices.sale) {
//         const newPrice = this.basePrices.sale * length;
//         const currencySymbol = this.getCurrencySymbol(salePriceEl.textContent);
//         salePriceEl.textContent = this.formatPrice(newPrice, currencySymbol);
//       }
      
//       // Update compare-at price if exists
//       const comparePriceEl = document.querySelector('.price__sale .price-item--regular');
//       if (comparePriceEl && this.basePrices.compare) {
//         const newPrice = this.basePrices.compare * length;
//         const currencySymbol = this.getCurrencySymbol(comparePriceEl.textContent);
//         comparePriceEl.textContent = this.formatPrice(newPrice, currencySymbol);
//       }
      
//       // Update unit price if exists
//       const unitPriceEl = document.querySelector('.unit-price .unit-price__price');
//       if (unitPriceEl && this.basePrices.unit) {
//         const newPrice = this.basePrices.unit * length;
//         const currencySymbol = this.getCurrencySymbol(unitPriceEl.textContent);
//         unitPriceEl.textContent = this.formatPrice(newPrice, currencySymbol);
//       }

//       // Update sticky buy bar price if exists
//       const buyBarPriceEl = document.querySelector('.product-buy-bar .price-item--regular');
//       if (buyBarPriceEl && this.basePrices.regular) {
//         const newPrice = this.basePrices.regular * length;
//         const currencySymbol = this.getCurrencySymbol(buyBarPriceEl.textContent);
//         buyBarPriceEl.textContent = this.formatPrice(newPrice, currencySymbol);
//       }
//     }

//     getCurrencySymbol(priceString) {
//       // Extract currency symbol from price string
//       const match = priceString.match(/[^\d.,\s]/);
//       return match ? match[0] : '£';
//     }
//   });
// }

// // Listen for variant changes and re-store base prices
// document.addEventListener('DOMContentLoaded', () => {
//   const variantSelectors = document.querySelectorAll('variant-selects, variant-radios');
  
//   variantSelectors.forEach(selector => {
//     selector.addEventListener('change', () => {
//       // Wait for price to update, then re-store base prices
//       setTimeout(() => {
//         const lengthSelector = document.querySelector('product-length-selector');
//         if (lengthSelector) {
//           lengthSelector.basePrices = lengthSelector.storBasePrices();
          
//           // Trigger price update with current length
//           const currentLength = parseFloat(lengthSelector.lengthMultiplier.value) || 1.0;
//           lengthSelector.updatePrices(currentLength);
//         }
//       }, 100);
//     });
//   });
// });



document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll("[data-length-slider]").forEach(function (slider) {

    slider.addEventListener("input", function () {

      const value = this.value + "m";
      const fieldset = this.closest(".length-option");

      // Update displayed value
      const display = fieldset.querySelector("[data-length-value]");
      if (display) {
        display.textContent = value;
      }

      // Select matching hidden radio
      const radio = [...fieldset.querySelectorAll('input[type="radio"]')]
        .find(r => r.value === value);

      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Show notification only for 5m
      const notification = document.querySelector(".length-notification");

      if (notification) {
        notification.style.display = (this.value == "5") ? "block" : "none";
      }

    });

  });

});